(ns machtfit.stepchall.help
  (:require [machtfit.stepchall.icons :as icons]))

(defn faq-url
  [{:keys [context question]}]
  (cond
    context (str "/stepchall/faq/" (name context) "/")
    question (str "/stepchall/faq/question/" (name question) "/")
    :else "/stepchall/faq/"))

(defn help [{:keys [text] :as target}]
  [:a.sc_help {:href (faq-url target)}
   [:i.sc_icon [icons/help]]
   text])
